import ptBR from './pt-BR';
import enUS from './en-US';
import esES from './es-ES';

export const translations = {
  'pt-BR': ptBR,
  'en-US': enUS,
  'es-ES': esES
};

export const SUPPORTED_LANGUAGES = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en-US', name: 'English', flag: '🇺' },
  { code: 'es-ES', name: 'Español', flag: '🇪' }
];

export const DEFAULT_LANGUAGE = 'pt-BR';